import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import IllustrationCategory from '../../../domain/entities/IllustrationCategory';

export default function reducer(
  state: {[key: number]: IllustrationCategory} = {},
  action: AnyAction,
): {[key: number]: IllustrationCategory} {
  switch (action.type) {
    case Types.IndexIllustrationCategoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: IllustrationCategory},
            record: IllustrationCategory,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowIllustrationCategorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
